import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const CheckSmall: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'check-small'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7073 8.29544C18.0976 8.68936 18.0976 9.32805 17.7073 9.72198L11.2075 16.2829C10.8162 16.6779 10.1779 16.6779 9.78667 16.2829L6.2927 12.7562C5.90243 12.3623 5.90243 11.7236 6.2927 11.3297C6.68297 10.9357 7.31573 10.9357 7.706 11.3297L10.4971 14.1469L16.294 8.29546C16.6843 7.90152 17.317 7.90151 17.7073 8.29544Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default CheckSmall
